import { render, staticRenderFns } from "./v-pill-shape-mismatch-popup.vue?vue&type=template&id=283ada44"
import script from "./v-pill-shape-mismatch-popup.vue?vue&type=script&lang=js"
export * from "./v-pill-shape-mismatch-popup.vue?vue&type=script&lang=js"
import style0 from "./v-pill-shape-mismatch-popup.vue?vue&type=style&index=0&id=283ada44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports